module.exports = __webpack_public_path__ + "static/media/how_it_work_1.5e7e3c45.png";